import * as React from "react";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";

type Props = {
  redirectUrl: string;
};

const navigateBack = (props) => {
  props.history.push(props.redirectUrl);
};

const backOfficeUnauthorised = (props: Props) => (
  <>
    <div style={{ margin: "15px" }}>Unauthorized</div>
    <Button
      style={{ width: "15px", marginLeft: "15px" }}
      color="primary"
      variant="contained"
      onClick={() => {
        navigateBack(props);
      }}
    >
      Back
    </Button>
  </>
);

export default withRouter(backOfficeUnauthorised);
